import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import Logo from '../assets/logo.svg';

const Footer = ({ handleScrollToSection }) => {
  return (
    <footer className="bg-[#080C26] h-full text-white px-6 py-10">
      <div className=" mx-auto flex flex-col lg:flex-row md:justify-center max-w-screen-md md:max-w-[90vw] lg:max-w-[80vw] xl:max-w-[80vw] 2xl:max-w-[70vw] gap-8 md:gap-14">
        {/* Logo & Branding */}
        <div
          className="flex flex-row items-center justify-center w-full  lg:justify-start lg:items-center gap-0 md:gap-4 cursor-pointer"
          onClick={() => handleScrollToSection("home")}
        >
          <div className='w-20 h-20'>
          <img
            src={Logo}
            alt="Logo"
            className="w-16 h-16 md:w-20 md:h-20"
          />
          </div>
          <div className='flex flex-col justify-center'>
          <div className="text-lg tracking-widest font-semibold">OPTIMUM</div>
          <div className="text-lg font-bold">CODES</div>
          </div>
        </div>

        {/* Social Media */}
        <div className="flex flex-col w-full items-center gap-4">
          <h4 className=" text-base md:text-lg font-semibold text-white">Follow Us</h4>
          <div className="flex gap-6">
            {/* <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebook className="text-white hover:text-blue-500 transition-transform transform hover:scale-110 text-xl" />
            </a>
            <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="text-white hover:text-pink-500 transition-transform transform hover:scale-110 text-xl" />
            </a> */}
            <a href="https://www.linkedin.com/company/optimum-codes/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin className="text-white hover:text-blue-300 transition-transform transform hover:scale-110 text-xl" />
            </a>
            {/* <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer">
              <FaXTwitter className="text-white hover:text-blue-400 transition-transform transform hover:scale-110 text-xl" />
            </a> */}
          </div>
        </div>

        {/* Contact Info */}
        <div className="flex flex-col w-full items-center lg:items-end text-sm text-gray-400 gap-2">
          <a href="tel:+917349349224" className="hover:text-white transition"> +91 73493 49224</a>
          <a href="mailto:team@optimumcodes.com" className="hover:text-white transition">team@optimumcodes.com</a>
        </div>
      </div>

      <div className="mt-10 text-center text-xs text-gray-500 border-t border-gray-700 pt-4">
        &copy; {new Date().getFullYear()} Optimum Codes. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
